module.exports = {"year":"{0}yr","month":"{0}mo","week":"{0}wk","day":"{0}d","hour":"{0}h","minute":"{0}m","second":"{0}s","now":"now"}


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/locale/en/tiny.json
// module id = 682
// module chunks = 0